import _suggestClose from "@zenlayer/zen-design-icons/assets/suggest/Close.svg";
import _LoadingOutlined from "@zenlayer/zen-design-icons/assets/LoadingOutlined.svg";
import _suggestCloseCircleFill from "@zenlayer/zen-design-icons/assets/suggest/CloseCircleFill.svg";
import _suggestWarningFill from "@zenlayer/zen-design-icons/assets/suggest/WarningFill.svg";
import _suggestInfoCircleFill from "@zenlayer/zen-design-icons/assets/suggest/InfoCircleFill.svg";
import _suggestCheckCircleFill from "@zenlayer/zen-design-icons/assets/suggest/CheckCircleFill.svg";
import { useControllableValue } from 'ahooks';
import classNames from 'classnames';
import React from 'react';
import { pickDomAttrs } from '../_util/utils';
import Icon from '../icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Icons = {
  success: /*#__PURE__*/_jsx(Icon, {
    type: "suggest/CheckCircleFill"
  }),
  info: /*#__PURE__*/_jsx(Icon, {
    type: "suggest/InfoCircleFill"
  }),
  warning: /*#__PURE__*/_jsx(Icon, {
    type: "suggest/WarningFill"
  }),
  error: /*#__PURE__*/_jsx(Icon, {
    type: "suggest/CloseCircleFill"
  }),
  loading: /*#__PURE__*/_jsx(Icon, {
    type: "LoadingOutlined"
  })
};
const Alert = props => {
  const {
    type = 'info',
    width,
    closeIcon,
    items,
    children,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    icon,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-alert");
  const attrs = pickDomAttrs(restProps);
  const [visible, onVisibleChange] = useControllableValue(props, {
    defaultValue: true,
    defaultValuePropName: 'defaultVisible',
    valuePropName: 'visible',
    trigger: 'onVisibleChange'
  });
  const closeIconProps = closeIcon ? closeIcon === true ? {} : closeIcon : null;
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    ...attrs.data,
    className: classNames(className, baseClassName, {
      ["".concat(baseClassName, "-").concat(type)]: !!type
    }),
    style: {
      width,
      ...style
    },
    children: [/*#__PURE__*/React.cloneElement(icon ? icon : Icons[type], {
      className: 'prefixIcon',
      fontSize: 16
    }), /*#__PURE__*/_jsx("span", {
      className: "content",
      children: items !== null && items !== void 0 && items.length ? items.map((item, index) => /*#__PURE__*/_jsxs("div", {
        className: "content-item",
        children: [items.length > 1 && /*#__PURE__*/_jsxs("div", {
          className: "content-item-index",
          children: [index + 1, "."]
        }), /*#__PURE__*/_jsx("div", {
          className: "content-item-text",
          children: item
        })]
      }, index)) : children
    }), !!closeIconProps && /*#__PURE__*/_jsx(Icon, {
      type: "suggest/Close",
      fontSize: 16,
      ...closeIconProps,
      className: classNames('closeIcon', closeIconProps.className),
      onClick: e => {
        var _closeIconProps$onCli;
        (_closeIconProps$onCli = closeIconProps.onClick) === null || _closeIconProps$onCli === void 0 || _closeIconProps$onCli.call(closeIconProps, e);
        onVisibleChange(false);
      }
    })]
  });
};
export default Alert;